import { axios } from "../../../lib/axios";

const buildSFTQuery = ({
    orgId = null,
    type = null,
    limit = null,
    pageNumber = 1,
    nextToken = null,
    encounterId = null,
    isAllUsersAllOrgs = false,
} = {}) => {
    const params = new URLSearchParams();

    if (type) params.append("type", type);
    if (limit != null) {
        params.append("limit", String(limit));
        params.append("pageNumber", String(pageNumber));
    }
    if (nextToken) params.append("nextToken", nextToken);
    if (orgId && orgId !== "All") params.append("orgId", orgId);
    if (encounterId) params.append("encounterId", encounterId);

    const query = params.toString();
    return query ? `/securefiletransfer?${query}` : "/securefiletransfer";
};

export const getSFTFullList = ({
    orgId = null,
    type = null,
    limit = 10,
    pageNumber = 1,
    nextToken = null,
    encounterId = null,
    isSuperAdmin = false,
    isAllUsersAllOrgs = false,
} = {}) => {
    if (isSuperAdmin && !orgId && !type && !limit && !nextToken && !encounterId) {
        return axios.get("/securefiletransfer");
    }

    return axios.get(
        buildSFTQuery({
            orgId,
            type,
            limit,
            pageNumber,
            nextToken,
            encounterId,
            isAllUsersAllOrgs,
        })
    );
};
